import script from "./details_page.vue?vue&type=script&setup=true&lang=js"
export * from "./details_page.vue?vue&type=script&setup=true&lang=js"

import "./details_page.vue?vue&type=style&index=0&id=ffe82c22&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffe82c22"]])

export default __exports__